import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import {
  booleanValueGetter,
  dateFormatter,
  nestedFieldValueGetter
} from 'utils/grid';

import { GridColDef } from '@mui/x-data-grid-pro';

import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';

export const useGetColumnDefs = () => {
  const { t } = useTranslation('common');

  const columnDefs: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'accountName',
        type: 'string',
        headerName: t('api_accounts.accountName'),
        flex: 1,
        minWidth: 200
      },
      {
        field: 'valid.from',
        type: 'date',
        headerName: t('validFrom'),
        valueGetter: nestedFieldValueGetter,
        valueFormatter: dateFormatter,
        flex: 1,
        minWidth: 120
      },
      {
        field: 'valid.to',
        type: 'date',
        headerName: t('validTo'),
        valueGetter: nestedFieldValueGetter,
        valueFormatter: dateFormatter,
        flex: 1,
        minWidth: 120
      },
      {
        field: 'DISABLED',
        type: 'string',
        valueGetter: booleanValueGetter,
        renderCell: BooleanCell,
        headerName: t('api_accounts.flags.DISABLED'),
        flex: 1,
        minWidth: 200
      },
      {
        field: 'LOCKED',
        type: 'string',
        valueGetter: booleanValueGetter,
        renderCell: BooleanCell,
        headerName: t('api_accounts.flags.LOCKED'),
        flex: 1,
        minWidth: 200
      }
    ];
  }, []);

  return columnDefs;
};
